import { useIntl } from 'react-intl';
import { useMutation } from '@tanstack/react-query';

import download from 'src/utils/download';
import { getRequest } from 'src/utils/request';
import {
  ErrorType,
  useMessageHandler,
} from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';

export type DownloadVerificationFileParamsType = {
  path: string;
  fileName?: string;
  contentType?: string;
};

const downloadVerificationFile = async ({
  path,
  fileName,
  contentType,
}: DownloadVerificationFileParamsType) => {
  const { data } = await getRequest(path, { responseType: 'blob' });
  download(data, fileName, contentType || 'application/octet-stream');
  return data;
};

export const useDownloadVerificationFile = () => {
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation<unknown, ErrorType, DownloadVerificationFileParamsType>({
    mutationFn: downloadVerificationFile,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.fileDownloaded), 1000);
    },
    onError: handleError,
  });
};
